import AppLogo from "../../logo.svg";

type Props = {
  width?: number;
  height?: number;
};

export default function Logo({ width = 50, height = 50 }: Props) {
  return <img src={AppLogo} alt="Logo" width={width} height={height} />;
}
